var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"segment debug-segment"},[_c('span',{staticClass:"width"},[_vm._v(_vm._s(_vm.windowWidth)+"px")]),_c('span',{staticClass:"breakpoint"},[_vm._v(_vm._s(_vm.breakpoint))])])}
var staticRenderFns = []

export { render, staticRenderFns }